'use client'

import { Insurance } from '@/screens/Insurance'

const ServicesInsurancePageContent = () => {
	return <Insurance />
}

export function ServicesInsuranceClient() {
	return <ServicesInsurancePageContent />
}
